import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "w-full border-b border-white/20 bg-transparent py-3 text-lg text-white placeholder:text-zinc-500 outline-none focus:border-[var(--acid)]";
const btn = "flex items-center gap-2 rounded-full bg-[var(--acid)] px-8 py-3 font-semibold text-[var(--ink)] disabled:opacity-60";

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Algo salió mal — Something went wrong";
};

const useSubmit = (fn) => {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await fn(); } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  return [busy, run];
};

export const ForgotForm = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, submit] = useSubmit(async () => {
    await axios.post(`${API}/admin/forgot-password`, { email });
    setSent(true);
  });
  return (
    <form data-testid="inbox-forgot-form" onSubmit={submit} className="mx-auto mt-24 max-w-md space-y-6">
      <h1 className="font-name text-5xl">Recuperar <span className="italic text-[var(--acid)]">acceso</span></h1>
      {sent ? (
        <p data-testid="inbox-forgot-sent" className="text-zinc-300">Si el email es correcto, te llegó un enlace para crear una nueva contraseña (válido 1 hora).</p>
      ) : (
        <>
          <input data-testid="inbox-forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={field} />
          <button data-testid="inbox-forgot-submit-btn" disabled={busy} className={btn}>{busy && <Loader2 size={16} className="animate-spin" />}Enviar enlace</button>
        </>
      )}
      <button type="button" data-testid="inbox-forgot-back-btn" onClick={onBack} className="text-sm text-zinc-400 underline">Volver a entrar</button>
    </form>
  );
};

export const ResetForm = ({ token, onDone }) => {
  const [password, setPassword] = useState("");
  const [busy, submit] = useSubmit(async () => {
    await axios.post(`${API}/admin/reset-password`, { token, password });
    toast.success("Contraseña actualizada. Ya puedes entrar.");
    onDone();
  });
  return (
    <form data-testid="inbox-reset-form" onSubmit={submit} className="mx-auto mt-24 max-w-md space-y-6">
      <h1 className="font-name text-5xl">Nueva <span className="italic text-[var(--acid)]">contraseña</span></h1>
      <input data-testid="inbox-reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 8 caracteres" className={field} />
      <button data-testid="inbox-reset-submit-btn" disabled={busy} className={btn}>{busy && <Loader2 size={16} className="animate-spin" />}Guardar</button>
    </form>
  );
};

export const ChangePasswordForm = ({ token, onClose }) => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, submit] = useSubmit(async () => {
    await axios.post(`${API}/admin/change-password`, { current_password: cur, new_password: next }, { headers: { Authorization: `Bearer ${token}` } });
    toast.success("Contraseña cambiada");
    onClose();
  });
  return (
    <form data-testid="inbox-change-password-form" onSubmit={submit} className="mt-8 grid gap-4 rounded-3xl border border-white/10 bg-[var(--surface)] p-6 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
      <input data-testid="inbox-current-password-input" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Contraseña actual" className={field} />
      <input data-testid="inbox-new-password-input" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} placeholder="Nueva (mín. 8)" className={field} />
      <button data-testid="inbox-change-password-submit-btn" disabled={busy} className={btn}>{busy && <Loader2 size={16} className="animate-spin" />}Cambiar</button>
    </form>
  );
};
